import {
  ContentWorkflow,
  ListDraftContentsResponse,
  UserRoles,
} from '@amzn/awscat-pattern-library-service-model';
import constants from '../../common/constants';
import { WorkflowTableIdentity } from '../../common/CookieRegistry';
import {
  ApprovalsCol,
  ContainsCodeCol,
  ContentAudienceCol,
  ContentIdCol,
  ContentTypeCol,
  DisapprovalsCol,
  IsTestDataCol,
  OwnerCol,
  ReviewerContentNameCol,
  UpdatedDateCol,
  ReviewerContentActionCol,
} from '../workflow-viewer/ContentWorkflowColumnDefinitions';
import ContentTable from './ContentTable';
import ReviewRequestStatusColumn from '../workflow-viewer/ReviewRequestStatusColumn';
import React from 'react';

class ContentToReviewTable extends ContentTable {
  protected tableHeader = constants.CONTENT_TO_REVIEW_TABLE_HEADER;
  protected tableId = WorkflowTableIdentity.ContentToReview;
  // need user profile info, so it needs to be defined in here
  protected ReviewRequestActionCol = {
    cell: (i: ContentWorkflow) => (
      <ReviewRequestStatusColumn workflow={i} userProfile={this.props.userProfile} />
    ),
    header: '',
    id: 'reviewrequestaction',
  };
  protected columnDefinitions = [
    ContentIdCol,
    ContentAudienceCol,
    ReviewerContentNameCol,
    ContentTypeCol,
    OwnerCol,
    UpdatedDateCol,
    ApprovalsCol,
    DisapprovalsCol,
    IsTestDataCol,
    this.ReviewRequestActionCol,
    ContainsCodeCol,
    ReviewerContentActionCol,
  ];

  // @ts-expect-error TS2416 - strict migration
  protected allowedFilterTypes = ['contentType'];

  protected fetchWorkflows = async () => {
    const { userProfile } = this.props;

    const res: ListDraftContentsResponse = await this.mplServiceClient.listContentsAssignedToReview(
      userProfile.userId,
    );
    return res.workflows;
  };

  protected validateUserRole = () => {
    return true;
  };
}

export default ContentToReviewTable;
